import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {ToastService} from '../../services/toast.service';

@Component({
  selector: 'app-trocar-senha',
  templateUrl: './trocar-senha.component.html',
  styleUrls: ['./trocar-senha.component.scss']
})
export class TrocarSenhaComponent {

  senhaForm: FormGroup = new FormGroup({
    senhaNova: new FormControl('', Validators.required),
    senhaNovaConfirmacao: new FormControl('', Validators.required),
  });

  constructor(
    private modalCtrl: ModalController,
    private toastService: ToastService
  ) {
  }

  fecharClicked() {
    this.modalCtrl.dismiss();
  }

  atualizar() {
    if (this.senhaForm.invalid) {
      return;
    }

    if (this.senhaForm.get('senhaNova').value !== this.senhaForm.get('senhaNovaConfirmacao').value) {
      this.toastService.toastWarning('A senha nova e a confirmação de senha nova devem ser iguais.');
      return;
    }

    this.modalCtrl.dismiss(this.senhaForm.value);
  }

}
